import styled from 'styled-components';
import { flexFixedSizeItem } from '../../../../themes/architecture/css-helpers/flex';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';
import {JACKPOT_WIDGET} from '../../constants';
import {EXCLUSIVES_LIST_ICON} from "../../../../themes/css-global-classes";

export const ListTitleIconDefaultBox = styled.span`
    ${flexFixedSizeItem}
    display: inline-block;
    width: 3rem;
    height: 2.5rem;
    margin: 0 1rem 0 0;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    ${CssRule.For.mobile.build()} & {
        width: 2rem;
        height: 2rem;
    }

    .${JACKPOT_WIDGET} & {
        background-image: url("${props => props.theme.images.gamesListTitle.dailyJackpot.toString()}")
    }

    .${EXCLUSIVES_LIST_ICON} & {
        background-image: url("${props => props.theme.images.gamesListTitle.exclusive.toString()}")
    }
`;
